import { FC } from 'react';

import { FormikHelpers } from 'formik';
import { BaseModal } from 'wbs-components-lib';

import { useLazyExportTopUserWinStreaksQuery } from '@services';

import {
  ExportWinStreaksForm,
  ExportWinStreaksFormValues,
  INITIAL_EXPORT_WIN_STREAKS_VALUES,
} from '../../../BetSystemSettingsForms';

import { UserWinStreaksExportModalProps } from './types';

export const UserWinStreaksExportModal: FC<UserWinStreaksExportModalProps> = ({ isOpened, handleClose }) => {
  const [exportWinStreaks, { isLoading: isExporting }] = useLazyExportTopUserWinStreaksQuery();

  const onExportSubmit = async (
    formValues: ExportWinStreaksFormValues,
    { resetForm }: FormikHelpers<ExportWinStreaksFormValues>
  ) => {
    await exportWinStreaks({
      ...formValues,
      startDate: formValues.startDate.toISOString(),
      endDate: formValues.endDate.toISOString(),
    });

    resetForm();

    handleClose();
  };

  return (
    <BaseModal headerTitle="Export Win Streaks" isOpened={isOpened} handleClose={handleClose} isFooterNeeded={false}>
      <ExportWinStreaksForm
        submitButtonCaption="Export"
        initialValues={INITIAL_EXPORT_WIN_STREAKS_VALUES}
        isSubmitting={isExporting}
        onSubmit={onExportSubmit}
      />
    </BaseModal>
  );
};
